import { useState } from "react";
import { CheckSquare, FileDown, Tags, X } from "lucide-react";
import { toast } from "../../lib/notify";
import { http, toastApiError } from "../../lib/api";
import { BRANCH_TYPES, isCorrection } from "./LocTypeFields";
import ExportTemplateDialog from "../exports/ExportTemplateDialog";

// Filtre sonucu için toplu işlemler: seçili şubelere tür ata · filtre sonucunu (kendi sütun şablonunla) Excel'e al — düzeltme farkları şubeleri sayıma/dışa aktarıma girmez
export default function LocBulkBar({ projectId, visible: visibleAll, sel, setSel, onChanged }) {
  const visible = visibleAll.filter((l) => !isCorrection(l));
  const [type, setType] = useState("");
  const [busy, setBusy] = useState(false);
  const [exp, setExp] = useState(false);
  const allSelected = visible.length > 0 && visible.every((l) => sel.includes(l.id));
  const apply = async () => {
    if (!sel.length) return;
    if (!type) return toast.error("Önce şube türünü seçin");
    if (!window.confirm(`${sel.length} şubenin türü "${type}" olarak değiştirilsin mi?${type === "ATM" ? " (m² sıfırlanır; enlem/boylam/silim şube kartından girilir)" : " (varsa ATM konum/silim bilgileri temizlenir)"}`)) return;
    setBusy(true);
    try {
      const r = await http.put("/locations/bulk-type", { ids: sel, branch_type: type });
      toast.success(`${r.data.updated} şubenin türü ${r.data.branch_type} yapıldı`);
      setSel([]); onChanged?.();
    } catch (e) { toastApiError(e); }
    setBusy(false);
  };
  const hasAtm = visible.some((l) => l.branch_type === "ATM");
  return (
    <div className="flex items-center gap-2 flex-wrap rounded-md border border-slate-200 bg-white px-3 py-2" data-testid="loc-bulk-bar">
      <ExportTemplateDialog open={exp} onClose={() => setExp(false)} kind="locations" title={`Şube Listesi — Excel (${visible.length} şube)`} testid="lexp"
        endpoint={`/projects/${projectId}/locations-export`} filename="subeler-filtre" extraBody={{ ids: visible.map((l) => l.id) }}
        note={hasAtm ? "Enlem / Boylam / Aylık Silim yalnız ATM satırlarında dolar; diğer şubelerde boş kalır." : "Listede ATM yok: Enlem / Boylam / Aylık Silim sütunları Excel'e eklenmez."} />
      <button type="button" onClick={() => setSel(allSelected ? [] : visible.map((l) => l.id))} data-testid="loc-select-all" disabled={!visible.length}
        className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md border border-slate-300 text-xs font-semibold text-slate-700 hover:bg-slate-50 disabled:opacity-40">
        <CheckSquare className="w-3.5 h-3.5" /> {allSelected ? "Seçimi Kaldır" : `Listedekileri Seç (${visible.length})`}
      </button>
      <span className={`text-xs font-bold ${sel.length ? "text-amber-800" : "text-slate-400"}`} data-testid="loc-sel-count">{sel.length} şube seçili</span>
      {sel.length > 0 && <button type="button" onClick={() => setSel([])} className="text-slate-400 hover:text-red-600" title="Seçimi temizle" data-testid="loc-sel-clear"><X className="w-3.5 h-3.5" /></button>}
      <span className="mx-1 h-5 w-px bg-slate-200" />
      <Tags className="w-3.5 h-3.5 text-sky-700" />
      <span className="text-[10px] font-bold uppercase tracking-widest text-slate-600">Toplu Tür Ata</span>
      <select value={type} onChange={(e) => setType(e.target.value)} data-testid="loc-bulk-type" className={`px-2 py-1.5 text-xs border border-slate-300 rounded-md bg-white font-semibold ${type ? "text-slate-900" : "text-slate-400"}`}>
        <option value="">Seçiniz…</option>
        {BRANCH_TYPES.filter((t) => t !== "DÜZELTME").map((t) => <option key={t} value={t}>{t}</option>)}
      </select>
      <button type="button" onClick={apply} disabled={busy || !sel.length || !type} data-testid="loc-bulk-apply"
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-sky-700 text-white text-xs font-bold hover:bg-sky-800 disabled:opacity-40" title={!sel.length ? "Önce şube seçin" : !type ? "Şube türünü seçin" : ""}>
        Uygula{sel.length ? ` (${sel.length})` : ""}
      </button>
      <button type="button" onClick={() => setExp(true)} disabled={busy || !visible.length} data-testid="loc-export-filtered"
        className="ml-auto inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md border border-emerald-700 bg-emerald-50 text-emerald-800 text-xs font-semibold hover:bg-emerald-100 disabled:opacity-40" title="Filtre çubuğundaki sonucu (listedeki şubeler) seçtiğin sütunlarla Excel'e al; şablonu isimle kaydet">
        <FileDown className="w-3.5 h-3.5" /> Filtre Sonucunu Excel'e Al ({visible.length})
      </button>
    </div>
  );
}
